import { GetResponse } from '@withbioma/apitype-publicapi-public/lib/v1/transactions/api'

import API from '~/apis/client'

export async function get(transactionUuid: string) {
  return await API.handle(
    API.public.get<GetResponse>(`/public/v1/transactions/${transactionUuid}`)
  )
}
